import React from "react"
import { styled } from "@mui/material/styles"
import DocomoBusiness from "assets/images/DocomoBusiness.jpg"

const StyledImg = styled("img")({
  width: "79px",
  height: "25px",
  paddingRight: "10px",
})

const HeaderLogo = (props) => {
  return <StyledImg src={DocomoBusiness} alt="docomotitle" />
}

export default HeaderLogo
